module.exports = __webpack_public_path__ + "static/media/4.566e7f00.svg";